import { useRouteLoaderData } from 'react-router';
import type { RewarbleAccount } from '~/api/types/rewarble/RewarbleAccount';
import type { LangLayoutLoader } from '~/routes/($lang)'

export const useAccount = () => {
  const routeLoaderData = useRouteLoaderData<LangLayoutLoader>( 'routes/($lang)' );

  return routeLoaderData?.account as RewarbleAccount | undefined;
}
